import { Component, Input } from '@angular/core';

/**
 * > This component represents the Vertical Ink Bar.
 *  However this component does nothing, all the functionality
 *  is done from its parent.
 */
@Component({
    selector: 'easyroute-vertical-ink-bar',
    templateUrl: './vertical-ink-bar.component.html',
    styleUrls: ['./vertical-ink-bar.component.scss'],
})
export class VerticalInkBarComponent {
    /**
     * @ignore
     */
    constructor() {}
}
